module.exports = __webpack_public_path__ + "static/media/Ren-Hot-Pot.3301143c.png";